import types from '../actionTypes';

export const addImageMapRequest = payload => ({
    type: types.ADD_IMAGE_MAP_REQUEST,
    payload,
});
